import React, { Component } from "react";
import $ from "jquery";
import * as Connection from "./../libs/connections";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import Slider from "react-slick";

import CarAvatar from "./CarAvatar";

import "../styles/components/SliderOurCars.css";

export default class OurCars extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeElement: 0,
      error: false,
      componentTitle: "",
      elements: []
    };

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  next() {
    this.slider.slickNext();
  }

  previous() {
    this.slider.slickPrev();
  }

  async componentDidMount() {
    $(document).ready(function() {
      function changeLeftPaddingOurSliders() {
        if ($(".our-cars--header h4")[0]) {
          const fromLeft = $(".our-cars--header h4").offset().left;
          $(".our-cars-slider").css({ "padding-left": fromLeft + "px" });
        }
      }
      $(window).resize(function() {
        changeLeftPaddingOurSliders();
      });
      changeLeftPaddingOurSliders();
    });
    try {
      const response = await Connection.getAllCars();
      this.setState({
        elements: response
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  }

  render() {
    const {
      paddingTop,
      paddingBottom,
      hideButton,
      background,
      text,
      sectionNumber
    } = this.props;
    const settings = {
      dots: false,
      dotsClass: "slick-thumb",
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <div
        className={`our-cars ${background ? "background" : ""}`}
        style={{
          paddingTop: paddingTop + "px",
          paddingBottom: paddingBottom + "px"
        }}
      >
        <div className="our-cars--header container container-small">
          <div className="row">
            <div className="col-12">
              <h5>
                <span>{sectionNumber}</span>
              </h5>
            </div>
            <div className="col-12 col-md-6">
              <h4>{text}</h4>
            </div>
            <div className="col-12 col-md-6 text-right our-cars--buttons">
              <button
                className="btn-arrow btn-arrow--prev"
                onClick={this.previous}
              />
              <button
                className="btn-arrow btn-arrow--next"
                onClick={this.next}
              />
            </div>
          </div>
        </div>
        <div className="our-cars-slider">
          {this.state.elements.length > 0 && (
            <Slider ref={elem => (this.slider = elem)} {...settings}>
              {this.state.elements.map((elem, idx) => {
                if (
                  !(
                    this.props.carId !== undefined &&
                    this.props.carId === elem.id
                  )
                ) {
                  return <CarAvatar key={idx} carData={elem} />;
                } else {
                  return null;
                }
              })}
            </Slider>
          )}
        </div>
        {!hideButton && (
          <div className="our-cars--button container container-small">
            <div className="row">
              <div className="col-12 button--inner">
                <Link className="btn-general btn-general--primary" to="/flota">
                  Zobacz flotę 2
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

OurCars.propTypes = {
  paddingTop: PropTypes.number,
  text: PropTypes.string.isRequired,
  paddingBottom: PropTypes.number,
  hideButton: PropTypes.bool,
  sectionNumber: PropTypes.string.isRequired,
  carCategory: PropTypes.number,
  carId: PropTypes.number
};

OurCars.defaultProps = {
  paddingTop: 0,
  paddingBottom: 0,
  hideButton: false
};
